import { SectionResponse } from '../@types/ResumePetisSimulationProposal'

export const sortQuestionnaireResume = (sections: SectionResponse[] = []) =>
  sections
    .map((section) => ({
      ...section,
      order: Number(
        (section?.questions?.[0]?.questionOrder || '')?.toString().charAt(0),
      ),
      questions: section?.questions?.sort(
        (a: any, b: any) => a.questionOrder - b.questionOrder,
      ),
    }))
    .sort((a, b) => a.order - b.order)
